module.exports = __webpack_public_path__ + "assets/RetinaNarr-BookItalic.c8894f9bac534762b3b4d0eb58a97023.woff2";